import React from 'react';
import { Route } from 'react-router-dom';
import Classes from '../pages/classes/Classes';
import ClassesArchive from '../pages/classes/ClassesArchive';
import CreateClass from '../pages/classes/CreateClass';
import EditClass from '../pages/classes/EditClass';
import PermissionGuard from '../components/global/PermissionGuard';

const classesRoutes = (
    <>
        <Route path="/classes" element={<PermissionGuard permission="classes_list"><Classes /></PermissionGuard>} />
        <Route path="/classes/archive" element={<PermissionGuard permission="classes_archive_list"><ClassesArchive /></PermissionGuard>} />
        <Route path="/classes/create" element={<PermissionGuard permission="classes_create"><CreateClass /></PermissionGuard>} />
        <Route path="/classes/:id/edit" element={<PermissionGuard permission="classes_edit"><EditClass /></PermissionGuard>} />
    </>
);

export default classesRoutes;
